import { Spacing } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import Paper from "@mui/material/Paper";

export const ModalPaperCustom = styled(Paper)`
  padding: ${Spacing[1500]} !important;
  border-radius: ${Spacing[750]} !important;
`;
